module.exports = __webpack_public_path__ + "static/simple-heart-28d46f77abeb7d6f9212acaabf507ae7.svg";